/* ==================================================
   NOTEPAD PAGE

   Purpose:
   Loads the full Notepad experience and provides
   the page-level layout and header.

   ================================================== */

import React from "react";
import Notepad from "../components/notepad/Notepad";
import "../components/notepad/Notepad.css";

const NotepadPage = () => {
    return (
        <div className="notepad-page">

            {/* ==================================================
                PAGE HEADER
                Purpose:
                Displays page title and description.
               ================================================== */}
            <div className="notepad-page-header">
                <div>
                    <h1>📝 Notepad</h1>
                    <p>Manage center notes, tags, reminders, and exports.</p>
                </div>
            </div>

            {/* ==================================================
                NOTEPAD CONTAINER
                Purpose:
                Loads the main Notepad component.
               ================================================== */}
            <div className="notepad-page-card">
                <Notepad />
            </div>
        </div>
    );
};

export default NotepadPage;